import React from "react";
import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  Calendar,
  List,
  Info,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { DatePicker } from "antd";

const EmailNotification = () => {
  const interviewFormat = [
    { value: "Choose", label: "Choose" },
    { value: "Phone", label: "Phone" },
    { value: "Virtual", label: "Virtual" },
    { value: "Face to Face", label: "Face to Face" },
  ];
  const Interviewers = [
    { value: "Choose", label: "Choose" },
    { value: "Ashok Kumar", label: "Ashok Kumar" },
    { value: "Pankaj Y", label: "Pankaj Y" },
    { value: "Thripati M", label: "Thripati M" },
    { value: "Prakash D", label: "Prakash D" },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/applicantTracking/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Email Notifications
                  </h4>
                </ol>
              </nav>
              <h6>Send Email to Candidate here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <RefreshIcon />
            <CollapesIcon />
            <li>
              <div className="page-btn">
                <Link
                  //   to={route.applicanttrackingapplicants}
                  className="btn btn-secondary"
                >
                  <ArrowLeft className="me-2" />
                  Back to Applicants
                </Link>
              </div>
            </li>
          </ul>
        </div>
        <form className="add-product-form ">
          <div className="add-product">
            <div
              className="accordions-items-seperate"
              id="accordionSpacingExample"
            >
              <div className="accordion-item border mb-4">
                <h2 className="accordion-header" id="headingSpacingOne">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingOne"
                    aria-expanded="true"
                    aria-controls="SpacingOne"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <Info className="text-primary me-2" />
                        <span>Email Information</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingOne"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email<span className="text-danger ms-1">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            value="venky@perennialcode.in"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Subject<span className="text-danger ms-1">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Role Details
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Interview Format
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            options={interviewFormat}
                            placeholder="Choose"
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Interview Location
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="input-blocks">
                          <label className="form-label">
                            Date & Time
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <div className="input-groupicon calender-input">
                            <Calendar className="info-img" />
                            <DatePicker
                              className="form-control datetimepicker"
                              placeholder="Select Date & Time"
                              showTime={{ format: "HH:mm" }}
                              format="DD/MM/YYYY HH:mm"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Interviewers
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            options={Interviewers}
                            placeholder="Choose"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item border mb-4">
                <h2 className="accordion-header" id="headingSpacingFour">
                  <div
                    className="accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    data-bs-target="#SpacingFour"
                    aria-expanded="true"
                    aria-controls="SpacingFour"
                  >
                    <div className="d-flex align-items-center justify-content-between flex-fill">
                      <h5 className="d-flex align-items-center">
                        <List
                          data-feather="list"
                          className="text-primary me-2"
                        />
                        <span>Additional Details</span>
                      </h5>
                    </div>
                  </div>
                </h2>
                <div
                  id="SpacingFour"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingSpacingFour"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            What to Wear(Optional)
                            {/* <span className="text-danger ms-1">*</span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Ex: Formal"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            List of Items to Bring(Optional)
                            {/* <span className="text-danger ms-1">*</span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Ex: resume, id proof, call letter"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Travel Suggestions(Optional)
                            {/* <span className="text-danger ms-1">*</span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Ex: Metro is available "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Talking Points(Optional)
                            {/* <span className="text-danger ms-1">*</span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Ex: prepare for written test"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="d-flex align-items-center justify-content-end mb-4">
              <button type="submit" className="btn btn-primary">
                Send Mail
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailNotification;
